import { render, staticRenderFns } from "./editParentStore.vue?vue&type=template&id=56aed435"
import script from "./editParentStore.vue?vue&type=script&lang=js"
export * from "./editParentStore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports